import '../../App.css'
import HeroSection from '../HeroSection'
import React from 'react';
import Footer from '../Footer';


function Home () {
    return(
        <>
        <HeroSection />
        <Footer />
        </>
    );
}

export default Home;